import * as request from "../utils/request"
import * as helper from "../utils/helper"
import * as ua from "../utils/ua"
import * as aes from "../utils/aes"

export function getCritialStrike(params, extend) {
  return new Promise((resolve, reject) => {
    let env = helper.getCgiEnv(params.sandbox)
    let urlParams = {
      from_https: 1,
      from_h5: 1,
      pf: "mds_wechat_qb-pay_html5-html5",
      pfkey: "pfkey",
      action: "query_baoji_times",
      openid: params.openid,
      openkey: params.openkey,
      session_id: params.sessionId,
      session_type: params.sessionType,
      wx_appid: params.wxAppid2,
      drm_info: `bargain_group=${params.bargainGroup}&version=3.0`,
      t: +new Date()
    }

    urlParams = helper.extend(
      urlParams,
      aes.encrypt(urlParams, ["product_id", "drm_info", "openid", "openkey", "session_id", "session_type"], params.sandbox)
    )

    if (extend) {
      urlParams = Object.assign(urlParams, extend)
    }

    request
      .ajax({
        url: `//${env}api.unipay.qq.com/v1/r/${params.offerId}/bargain_proc`,
        data: urlParams
      })
      .then(res => {
        if (res.ret == 0) {
          resolve(res)
        } else {
          reject(res)
        }
      })
      .catch(reject)
  })
}

export function getActivities(params, extend) {
  return new Promise((resolve, reject) => {
    let env = helper.getCgiEnv(params.sandbox)
    let urlParams = {
      from_https: 1,
      from_h5: 1,
      pf: "mds_wechat_qb-pay_html5-html5",
      pfkey: "pfkey",
      action: "query_activity",
      openid: params.openid,
      openkey: params.openkey,
      session_id: params.sessionId,
      session_type: params.sessionType,
      wx_appid: params.wxAppid2,
      drm_info: `bargain_group=${params.bargainGroup}&version=3.0`,
      t: +new Date()
    }

    urlParams = helper.extend(
      urlParams,
      aes.encrypt(urlParams, ["product_id", "drm_info", "openid", "openkey", "session_id", "session_type"], params.sandbox)
    )

    if (extend) {
      urlParams = Object.assign(urlParams, extend)
    }

    request
      .ajax({
        url: `//${env}api.unipay.qq.com/v1/r/${params.offerId}/bargain_proc`,
        data: urlParams
      })
      .then(res => {
        if (res.ret == 0) {
          resolve(res.info)
        } else {
          reject(res)
        }
      })
      .catch(reject)
  })
}

export function getBargains(params) {
  return new Promise((resolve, reject) => {
    let env = helper.getCgiEnv(params.sandbox)
    let urlParams = {
      from_https: 1,
      from_h5: 1,
      pf: "mds_wechat_qb-pay_html5-html5",
      pfkey: "pfkey",
      action: "query_bargain_detail",
      openid: params.openid,
      openkey: params.openkey,
      session_id: params.sessionId,
      session_type: params.sessionType,
      wx_appid: params.wxAppid2,
      drm_info: `bargain_group=${params.bargainGroup}&version=3.0&bargain_id=${params.bargainId}`,
      current_page: params.currentPage,
      page_size: params.pageSize,
      t: +new Date()
    }

    urlParams = helper.extend(
      urlParams,
      aes.encrypt(urlParams, ["product_id", "drm_info", "openid", "openkey", "session_id", "session_type"], params.sandbox)
    )

    request
      .ajax({
        url: `//${env}api.unipay.qq.com/v1/r/${params.offerId}/bargain_proc`,
        data: urlParams
      })
      .then(res => {
        if (res.ret == 0) {
          resolve(res.info)
        } else {
          reject(res)
        }
      })
      .catch(reject)
  })
}

export function openBargain(params, extendParams) {
  return new Promise((resolve, reject) => {
    let env = helper.getCgiEnv(params.sandbox)
    let urlParams = {
      from_https: 1,
      from_h5: 1,
      pf: "mds_wechat_qb-pay_html5-html5",
      pfkey: "pfkey",
      action: "open",
      openid: params.openid,
      openkey: params.openkey,
      session_id: params.sessionId,
      session_type: params.sessionType,
      wx_appid: params.wxAppid2,
      drm_info: `bargain_group=${params.bargainGroup}&version=3.0`,
      product_id: params.productId
    }

    urlParams = helper.extend(
      urlParams,
      aes.encrypt(urlParams, ["product_id", "drm_info", "openid", "openkey", "session_id", "session_type"], params.sandbox)
    )

    if (extendParams) {
      urlParams = Object.assign(urlParams, extendParams)
    }
    request
      .ajax({
        url: `//${env}api.unipay.qq.com/v1/r/${params.offerId}/bargain_proc`,
        data: urlParams
      })
      .then(res => {
        if (res.ret == 0) {
          resolve(res.info)
        } else {
          reject(res)
        }
      })
      .catch(reject)
  })
}

export function helpBargain(params) {
  return new Promise((resolve, reject) => {
    let env = helper.getCgiEnv(params.sandbox)
    let urlParams = {
      from_https: 1,
      from_h5: 1,
      pf: "mds_wechat_qb-pay_html5-html5",
      pfkey: "pfkey",
      action: params.action || "bargain",
      openid: params.openid,
      openkey: params.openkey,
      session_id: params.sessionId,
      session_type: params.sessionType,
      wx_appid: params.wxAppid2,
      drm_info: `bargain_group=${params.bargainGroup}&version=3.0&bargain_id=${params.bargainId}`,
      product_id: params.productId
    }

    urlParams = helper.extend(
      urlParams,
      aes.encrypt(urlParams, ["product_id", "drm_info", "openid", "openkey", "session_id", "session_type"], params.sandbox)
    )

    request
      .ajax({
        url: `//${env}api.unipay.qq.com/v1/r/${params.offerId}/bargain_proc`,
        data: urlParams
      })
      .then(res => {
        if (res.ret == 0) {
          resolve(res.info)
        } else {
          reject(res)
        }
      })
      .catch(reject)
  })
}

export function getMyBargains(params) {
  return new Promise((resolve, reject) => {
    let env = helper.getCgiEnv(params.sandbox)
    let urlParams = {
      from_https: 1,
      from_h5: 1,
      pf: "mds_wechat_qb-pay_html5-html5",
      pfkey: "pfkey",
      action: "query_my_bargain",
      openid: params.openid,
      openkey: params.openkey,
      session_id: params.sessionId,
      session_type: params.sessionType,
      wx_appid: params.wxAppid2,
      drm_info: `bargain_group=${params.bargainGroup}&version=3.0`,
      t: +new Date()
    }

    urlParams = helper.extend(
      urlParams,
      aes.encrypt(urlParams, ["product_id", "drm_info", "openid", "openkey", "session_id", "session_type"], params.sandbox)
    )

    request
      .ajax({
        url: `//${env}api.unipay.qq.com/v1/r/${params.offerId}/bargain_proc`,
        data: urlParams
      })
      .then(res => {
        if (res.ret == 0) {
          if (res.info && res.info.bargain_mpinfo && res.info.bargain_mpinfo.bargain_info) {
            resolve(res.info.bargain_mpinfo.bargain_info)
          } else {
            resolve([])
          }
        } else {
          reject(res)
        }
      })
      .catch(reject)
  })
}

export function pay(params, extend) {
  return new Promise((resolve, reject) => {
    let env = helper.getCgiEnv(params.sandbox),
      userAgent = ua.getUserAgent(),
      urlParams = {
        from_https: 1,
        from_h5: 1,
        pf: params.pf,
        pfkey: "pfkey",
        accounttype: "qb",
        openid: params.openid,
        openkey: params.openkey,
        session_id: params.sessionId,
        session_type: params.sessionType,
        wx_appid: params.wxAppid2,
        zoneid: 1,
        gameid: params.gameId,
        payitem: [params.productId, params.productNum, params.offerId].join("*"),
        is_bargain: 1,
        change_wx_openid: 1,
        goodsmeta: encodeURIComponent(params.productName) + "*desc",
        game_platform_id: userAgent.iOS ? 0 : 1
      }

    urlParams = helper.extend(urlParams, aes.encrypt(urlParams, ["openid", "openkey", "session_id", "session_type"], params.sandbox))

    if (extend) {
      urlParams = Object.assign(urlParams, extend)
    }

    request
      .ajax({
        url: `//${env}api.unipay.qq.com/v1/r/${params.offerId}/activity_proc`,
        data: urlParams
      })
      .then(res => {
        if (res.ret == 0) {
          resolve(res)
        } else {
          reject(res)
        }
      })
      .catch(reject)
  })
}

export function mobileSaveGoods(params, extend) {
  return new Promise((resolve, reject) => {
    let env = helper.getCgiEnv(params.sandbox),
      urlParams = {
        out_trade_no: params.out_trade_no,
        from_https: 1,
        from_h5: 1,
        pf: params.pf,
        pfkey: "pfkey",
        openid: params.openid,
        openkey: params.openkey,
        session_id: params.sessionId,
        session_type: params.sessionType,
        wx_appid: params.wxAppid2,
        drm_info: `bargain_group=${params.bargainGroup}&version=3.0&bargain_id=${params.bargainId}`,
        token_id: params.token_id,
        inner_force_wxcommid: 1,
        pay_method: params.pay_method
      }

    urlParams = helper.extend(urlParams, aes.encrypt(urlParams, ["openid", "openkey", "session_id", "session_type"], params.sandbox))

    if (extend) {
      urlParams = Object.assign(urlParams, extend)
    }
    request
      .ajax({
        url: `//${env}api.unipay.qq.com/v1/${params.mid}/${params.offerId}/mobile_save_goods`,
        data: urlParams
      })
      .then(res => {
        if (res.ret == 0) {
          resolve(res)
        } else {
          reject(res)
        }
      })
      .catch(reject)
  })
}

export function initMidas() {
  return new Promise((resolve, reject) => {
    if (window.Midas) {
      resolve(window.Midas)
    } else {
      request
        .getScript("//midas.gtimg.cn/h5pay/js/api/midas.js")
        .then(() => {
          resolve(window.Midas)
        })
        .catch(error => {
          reject(error)
        })
    }
  })
}

export function sendQualication(params) {
  return new Promise((resolve, reject) => {
    let env = helper.getCgiEnv(params.sandbox)

    params = helper.extend(
      {
        pf: "mds_wechat_qb-pay_html5.game-html5",
        pfkey: "pfkey",
        from_https: 1,
        from_h5: 1
      },
      params
    )

    request
      .ajax({
        url: `//${env}api.unipay.qq.com/v1/r/${params.offerId}/follow_activity`,
        data: params
      })
      .then(res => {
        if (res.ret == 0) {
          resolve(res)
        } else {
          reject(res)
        }
      })
      .catch(reject)
  })
}
